// Module
var code = `<h4><span>SUBTOPIC:</span> {{title}}</h4>
`;
// Exports
module.exports = code;